$(document).ready(function() {

  /***** Navigation Interactions *****/

  // Nav Click - Logo Click
  $('header .main_header__logo').click(function() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'nav_click',
      click_type: 'logo',
      section: 'logo',
      link_text: "julep",
      link_type: "logo",
      link_path: "/",
      sub_section: undefined
    });
  });

  // Nav Click - Utility
  document.querySelectorAll("header .header__buttons a").forEach(link => {
    link.addEventListener('click', function(e) {
      const current_link = this.getAttribute('href');
      const current_title = this.getAttribute('aria-label');
      const current_level = 'utility';

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'nav_click',
        section: 'utility',
        sub_section: undefined,
        link_type: current_level,
        link_text: current_title.toLowerCase(),
        link_path: current_link
      });
    });
  });

  // Nav Click - Top Level Parent
  document.querySelectorAll(".menu__item-top-level").forEach(link => {
    link.addEventListener('click', function(e) {
      const current_link = this.getAttribute('href');
      const current_title = this.getAttribute('title');
      const current_level = 'top level';

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'nav_click',
        section: current_title,
        sub_section: undefined,
        link_type: current_level,
        link_text: current_title,
        link_path: current_link
      });
    });
  });

  // Nav Click - Bottom Level Parent
  document.querySelectorAll(".mega-menu__container .custom-card__wrapper").forEach(link => {
    link.addEventListener('click', function(e) {
      const parent_title = this.getAttribute('parent');
      const current_link = this.getAttribute('href');
      const current_title = this.getAttribute('title');
      const current_level = 'bottom level';

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'nav_click',
        section: parent_title,
        sub_section: current_title,
        link_type: current_level,
        link_text: current_title,
        link_path: current_link
      });
    });
  });

  // Hamburger Click - Logo Click
  $('.menu-drawer .header__logo--image').click(function() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'hamburger_nav_click',
      section: 'logo',
      link_text: "julep",
      link_type: "logo",
      link_path: "/",
      sub_section: undefined
    });
  });

  // Hamburger Nav Click - Link
  document.querySelectorAll(".menu-drawer__menus a.menu-drawer__item-link").forEach(link => {
    link.addEventListener('click', function(e) {
      const parent_title = this.textContent.trim();
      const current_link = this.getAttribute('href');
      const current_title = this.textContent.trim();
      const current_level = 'top level';

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'hamburger_nav_click',
        section: parent_title.toLowerCase(),
        sub_section: current_title.toLowerCase(),
        link_type: current_level,
        link_text: current_title.toLowerCase(),
        link_path: current_link
      });
    });
  });

  // Hamburger Nav Click - Sub Link
  document.querySelectorAll(".menu-drawer__submenu .custom-card__wrapper").forEach(link => {
    link.addEventListener('click', function(e) {
      const parent_title = this.getAttribute('parent');
      const current_link = this.getAttribute('href');
      const current_title = this.getAttribute('title');
      const current_level = 'bottom level';

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'hamburger_nav_click',
        section: parent_title,
        sub_section: current_title,
        link_type: current_level,
        link_text: current_title,
        link_path: current_link
      });
    });
  });

  // Hamburger Nav Click - Social Link
  document.querySelectorAll(".menu-drawer__footer a.social__link").forEach(link => {
    link.addEventListener('click', function(e) {
      const current_link = this.getAttribute('href');
      const current_title = this.getAttribute('title');
      const current_level = 'social bar';

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'hamburger_nav_click',
        section: undefined,
        sub_section: undefined,
        link_type: current_level,
        link_text: current_title,
        link_path: current_link
      });
    });
  });


  /***** Page Interactions *****/

  // Slideshows
  $('.section--slideshow a.btn').click(function() {
    var current_link = $(this).attr('href') || undefined;
    var current_title = $(this).text().trim().toLowerCase() || undefined;
    var slideshow_first_title = $(this).closest('.swiper-wrapper').find('.swiper-slide[slide-index="1"]').find('.slideshow__title').text().trim().toLowerCase() || undefined;
    var slideshow_current_title = $(this).closest('.slideshow__content').find('.slideshow__title').text().trim().toLowerCase() || undefined;
    var slide_index = $(this).closest('.swiper-slide').attr('slide-index') || undefined;

    window.dataLayer.push({
      event: 'page_interaction',
      click_type: 'slide button',
      component_name: 'slideshow',
      component_id: slideshow_first_title,
      link_text: current_title,
      link_path: current_link,
      product_name: undefined,
      collection_name: undefined,
      slide_index: slide_index,
      active_state: slideshow_current_title
    });
  });

  // Image with Text
  $('.original-image-with-text a.btn').click(function() {
    var current_link = $(this).attr('href') || undefined;
    var current_title = $(this).text().trim().toLowerCase() || undefined;
    var image_with_text_title = $(this).closest('.original-image-with-text').find('.rich-text__heading').text().trim().toLowerCase() || undefined;

    window.dataLayer.push({
      event: 'page_interaction',
      click_type: 'section button',
      component_name: 'image with text',
      component_id: image_with_text_title,
      link_text: current_title,
      link_path: current_link,
      product_name: undefined,
      collection_name: undefined,
      slide_index: undefined,
      active_state: undefined
    });
  });

  // Testimonials
  $('.testimonials-wrapper a.testimonial__product').click(function() {
    var current_link = $(this).attr('href') || undefined;
    var current_title = $(this).text().trim().toLowerCase() || undefined;
    var testimonials_title = $(this).closest('.testimonials-wrapper').find('.rich-text__heading').text().trim().toLowerCase() || undefined;

    window.dataLayer.push({
      event: 'page_interaction',
      click_type: 'testimonial product',
      component_name: 'testimonials',
      component_id: testimonials_title,
      link_text: current_title,
      link_path: current_link,
      product_name: current_title,
      collection_name: undefined,
      slide_index: undefined,
      active_state: undefined
    });
  });

  // Product Tabs - Tab Nav
  $('tabs-component button.tabs__tab').click(function() {
    var section_heading = $(this).closest('.tabs__header').find('.section__heading').text().trim().toLowerCase() || undefined;   
    var active_tab_title = $(this).closest('.tabs__nav').find('.tabs__tab[aria-selected="true"]').text().trim().toLowerCase() || undefined;
    var current_tab_title = $(this).text().trim().toLowerCase() || undefined;

    window.dataLayer.push({
      event: 'page_interaction',
      click_type: 'tab',
      component_name: 'product tabs',
      component_id: section_heading,
      active_state: active_tab_title,
      link_text: current_tab_title,
      link_path: undefined,
      product_name: undefined,
      collection_name: undefined,
      slide_index: undefined
    });
  });

  // Product Tabs - Tab Nav - Shop All
  $('tabs-component .section__btn a').click(function() {
    var section_heading = $(this).closest('.tabs__header').find('.section__heading').text().trim().toLowerCase() || undefined;   
    var active_tab_title = $(this).closest('tabs-component').find('.tabs__nav').find('.tabs__tab[aria-selected="true"]').text().trim().toLowerCase() || undefined;
    var button_title = $(this).text().trim().toLowerCase() || undefined;
    var button_link = $(this).attr('href').trim().toLowerCase() || undefined;

    window.dataLayer.push({
      event: 'page_interaction',
      click_type: 'tab',
      component_name: 'product tabs',
      component_id: section_heading,
      active_state: active_tab_title,
      link_text: button_title,
      link_path: button_link,
      product_name: undefined,
      collection_name: undefined,
      slide_index: undefined
    });
  });

  // Product Tabs - Cards
  $('tabs-component .product-card').click(function() {
    var section_heading = $(this).closest('tabs-component').find('.tabs__header').find('.section__heading').text().trim().toLowerCase() || undefined;   
    var active_tab_title = $(this).closest('tabs-component').find('.tabs__nav').find('.tabs__tab[aria-selected="true"]').text().trim().toLowerCase() || undefined;
    var product_title = $(this).find('.product-card__title').text().trim().toLowerCase() || undefined;
    var product_link = $(this).find('.product-card__title a').attr('href') || undefined;

    window.dataLayer.push({
      event: 'page_interaction',
      click_type: 'product card',
      component_name: 'product tabs',
      component_id: section_heading,
      active_state: active_tab_title,
      link_text: product_title,
      link_path: product_link,
      product_name: product_title,
      collection_name: undefined,
      slide_index: undefined
    });
  });

  // Collection List - Cards
  $('.section.collection-list .collection-card').click(function() {
    var section_heading = $(this).closest('.collection-list').find('.rich-text__heading').text().trim().toLowerCase() || undefined;   
    var collection_title = $(this).find('a').attr('aria-label').trim().toLowerCase() || undefined;
    var collection_link = $(this).find('a').attr('href') || undefined;

    window.dataLayer.push({
      event: 'page_interaction',
      click_type: 'collection',
      component_name: 'collection list',
      component_id: section_heading,
      active_state: undefined,
      link_text: collection_title,
      link_path: collection_link,
      product_name: undefined,
      collection_name: undefined,
      slide_index: undefined
    });
  });

  // PDP - Filters
  $('.shade_category_option_wrapper .shade_category_option').click(function() {
    var filter_title =  $(this).text().trim().toLowerCase() || undefined;
    var product_title = $(this).closest('.shade_category_option_wrapper').attr('product').trim().toLowerCase() || undefined;

    window.dataLayer.push({
      event: 'page_interaction',
      click_type: 'shade filters',
      component_name: 'product information',
      link_text: filter_title,
      product_name: product_title,
      link_path: undefined,
      component_id: undefined,
      active_state: undefined,
      collection_name: undefined,
      slide_index: undefined
    });
  });

  // PDP - Color Swatches
  $('.product__block--variant_picker variant-selects .swatch-wrapper').click(function() {
    var product_title =  $(this).attr('product-name').trim().toLowerCase() || undefined;
    var swatch_title = $(this).attr('title').trim().toLowerCase() || undefined;

    window.dataLayer.push({
      event: 'page_interaction',
      click_type: 'color swatches',
      component_name: 'product information',
      link_text: swatch_title,
      product_name: product_title,
      link_path: undefined,
      component_id: undefined,
      active_state: undefined,
      collection_name: undefined,
      slide_index: undefined
    });
  });

  // PDP - Accordion
  $('.product__block--collapsible_tab .accordion-details__summary').click(function() {
    var accordion_heading = $(this).find('h2').text().trim().toLowerCase() || undefined;   
    var product_title =  $(this).closest('.product__info-container').attr('product-name').trim().toLowerCase() || undefined;

    window.dataLayer.push({
      event: 'page_interaction',
      click_type: 'collapsible row',
      component_name: 'product information',
      component_id: accordion_heading,
      active_state: undefined,
      link_text: accordion_heading,
      link_path: undefined,
      product_name: product_title,
      collection_name: undefined,
      slide_index: undefined
    });
  });

  // PDP - Gallery Zoom
  $('.product__media-zoom').click(function() {
    var index = parseInt($(this).attr('data-media-index')) + 1 || undefined;
    var image_alt = $(this).closest('.product__media-container').find('img').attr('alt').toLowerCase() || undefined;   
    var product_title =  $(this).closest('media-gallery').attr('product').toLowerCase() || undefined;

    window.dataLayer.push({
      event: 'page_interaction',
      click_type: 'zoom navigation',
      component_name: 'product information',
      component_id: image_alt,
      active_state: undefined,
      link_text: image_alt,
      link_path: undefined,
      product_name: product_title,
      collection_name: undefined,
      slide_index: index
    });
  });

  // Product Recommendations - Cards
  // $('.related-products .product-card').click(function() {
  //   var section_heading = $(this).closest('.').find('.section__heading').text().trim().toLowerCase() || undefined;   
  //   var product_title = $(this).find('.product-card__title').text().trim().toLowerCase() || undefined;
  //   var product_link = $(this).find('.product-card__title a').attr('href') || undefined;

  //   window.dataLayer.push({
  //     event: 'page_interaction',
  //     click_type: 'product card',
  //     component_name: 'related products',
  //     component_id: section_heading,
  //     active_state: undefined,
  //     link_text: product_title,
  //     link_path: product_link,
  //     product_name: product_title,
  //     collection_name: undefined,
  //     slide_index: undefined
  //   });

  /***** Footer Interactions *****/

  // Footer - Menu
  $('.footer .footer-accordion-details a').click(function() {
    var current_link = $(this).attr('href') || undefined;
    var current_title = $(this).text().trim().toLowerCase() || undefined;
    var section_title = $(this).closest('.footer-accordion-details').find('.footer-block__heading').text().trim().toLowerCase() || undefined;

    window.dataLayer.push({
      event: 'footer_menu_click',
      click_type: 'footer menu',
      section: section_title,
      link_text: current_title,
      link_path: current_link,
    });
  });

  // Footer - Social Bar
  $('.footer .social__item a').click(function() {
    var current_link = $(this).attr('href') || undefined;
    var current_title = $(this).attr('title').toLowerCase() || undefined;
    var section_title = $(this).closest('.footer-accordion-details').find('.footer-block__heading').text().trim().toLowerCase() || undefined;

    window.dataLayer.push({
      event: 'footer_menu_click',
      click_type: 'social bar',
      section: undefined,
      link_text: current_title,
      link_path: current_link,
    });
  });
  
  // Footer - Klaviyo Newsletter Forms

  window.addEventListener("klaviyoForms", function(e) { 
    // Footer - Klaviyo Email Newsletter
    if (e.detail.type == 'submit' && e.detail.formId == 'YwceLY') {
      window.dataLayer.push({
        event: 'footer_menu_click',
        click_type: 'newsletter email signup',
        section: 'just one swipe away',
        link_text: 'subscribe',
        link_path: undefined,
      });
    } 

    // Footer - Klaviyo Mobile Newsletter
    else if (e.detail.type == 'submit' && e.detail.formId == 'SETdNb') {
      window.dataLayer.push({
        event: 'footer_menu_click',
        click_type: 'newsletter mobile signup',
        section: 'just one swipe away',
        link_text: 'subscribe',
        link_path: undefined,
      });
    }
  });

});


